import React from "react";
import {CreateOption} from "./options";
import {
  Options,
  OptionsBody,
  OptionsHeader,
  OptionsHeaderGroup,
  OptionsImage,
  OptionsImageContainer,
  OptionsSmallText,
  OptionsTagText,
  OptionsText,
  TagContainer,
} from "./options.styles";
import {Col} from "antd";

interface OptionTileProps {
  option: CreateOption;
  index: number;
  showComingSoon?: boolean;
  onClick?: (option: CreateOption) => void;
  colors: string[];
  selected?: boolean;
}

export const OptionTile: React.FC<OptionTileProps> = ({
  option,
  index,
  showComingSoon,
  onClick,
  colors,
  selected,
}) => {
  const handleClick = () => {
    onClick?.(option);
  };
  return (
    <Col key={option.id} xs={24} sm={12} md={12} lg={12} xl={8}>
      <Options onClick={handleClick} selected={selected}>
        <div>
          <OptionsHeader color={option.bgColor}>
            <OptionsHeaderGroup>
              <OptionsSmallText isBold color={option.borderColor} fontSize={10}>
                {option.label}
              </OptionsSmallText>
              {option.tag && (
                // <Tag color="#FA541C"> {option.tag}</Tag>
                <TagContainer>
                  <OptionsTagText isBold>{option.tag}</OptionsTagText>
                </TagContainer>
              )}
            </OptionsHeaderGroup>

            <OptionsImageContainer borderColor={option.borderColor}>
              <OptionsImage
                src={option?.img}
                rounded
                width="75px"
                height="50px"
                alt="new offering image"
              />
            </OptionsImageContainer>
          </OptionsHeader>
        </div>
        <OptionsBody>
          <OptionsText fontSize={12}>{option.description}</OptionsText>
        </OptionsBody>
      </Options>
    </Col>
  );
};
